module.exports = __webpack_public_path__ + "static/media/29FUNOV14.9a1e65f5.jpg";